<!doctype html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <title i18n="@@app.logger.title">Title</title>
  </head>
  <body></body>
</html>
